import { Component } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { get } from 'lodash-es';
import { log } from 'src/app/core/log';
import { trackById } from 'src/app/core/track-by';

@Component({
  selector: 'app-select-drivers',
  templateUrl: './select-drivers.page.html',
  styleUrls: ['./select-drivers.page.scss'],
  standalone: false
})
export class SelectDriversPage {
  readonly trackById = trackById;
  drivers: any[] = [];
  selectedDriver: any = '';
  constructor(
    private navParam: NavParams,
    private modalController: ModalController
  ) {
    // `get('item')` es undefined si el modal se abre sin componentProps, y `distance`
    // no viene en los drivers que todavia no tienen posicion. Las dos cosas reventaban
    // en el constructor, o sea antes de que se pudiera mostrar ningun error.
    const drivers: any[] = this.navParam.get('item') ?? [];
    this.drivers = drivers.map((x) => ({ ...x, distance: Number(get(x, 'distance', 0)).toFixed(2) }));
    log('drivers->', this.drivers);
    if (this.drivers.length && this.drivers.length > 0) {
      this.selectedDriver = this.drivers[0].id;
    }
  }

  select() {
    // log(this.selectedDriver);
    const [selectedDriver] = this.drivers.filter((x) => x.id === this.selectedDriver);
    // log({ selectedDriver });
    void this.modalController.dismiss(selectedDriver, 'selected');
  }
  close() {
    void this.modalController.dismiss([], 'close');
  }
  getProfilePic(driver) {
    return get(driver, 'profilePicture', 'assets/imgs/user.png');
  }
}
